import { configureStore } from "@reduxjs/toolkit";
import { authSlice } from "./auth-slice";
import { orbitSlice } from "./orbit-slice";
import { communitySlice } from "./community-slice";
import loadingSlice from "./loading-slice/loading-slice";
import imageSlice from "./image-slice/image-slice";
import notificationSlice from "./notification-slice/notification-slice";
import planetSlice from "./planet-slice/planet-slice";

export const store = configureStore({
  reducer: {
    authReducer: authSlice,
    orbitReducer:orbitSlice,
    communityReducer:communitySlice,
    loadingReducer:loadingSlice,
    imageReducer:imageSlice,
    notificationReducer :notificationSlice,
    planetReducer:planetSlice,

  },
});
